import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	comboboxInput: {
		width: '100%',
		height: 42,
	},
	disabledWrapper: {
		cursor: 'not-allowed',
	},
	comboboxContent: {
		minWidth: 320,
	},
});
